
/**
* @name: index
* @author: weiyong
* @date: 2022-10-26 22:14
* @description：index
* @update: 2022-10-26 22:14
*/
<template>

  <input-editor :column="column"
                :disabled="readOnlyFlag?true:(editorFlag?false:(disabled||vuex['disabled']||disabledFun))"
                :cellContent="cellContent"
                @changeCellVal="changeCellVal"
                @initValidateFlag="initValidateFlag"
                :size="size" :validate="validate"
                :record="record"/>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "xmInputEditor",
});
</script>

<script lang="ts" setup>
import InputEditor from "@/main-page/gridCellEditor/editorCtls/InputEditor/index.vue";
import {useSimpleFlowAclHooks} from "@/main-page/gridCellEditor/hooks/useSimpleFlowAclHooks";
import {useVuexState} from "@/main-page/ctls/hooks/useVuexState";
import {CtlComEnum} from "@/main-page/enums/ctlComEnum";

interface IProps {
  size: string,
  validate: string,
  record: any,
  column: any,
  disabled: boolean,
  cellContent: any,
}

const props = withDefaults(defineProps<IProps>(), {
  size: 'default',
  record: {},
  column: {},
  validate: '',
  disabled: false,
  cellContent: null,
})
const {record,  column, validate} = toRefs(props);
const {vuex} = useVuexState({sectionConfig: column,record, vuexProps: [CtlComEnum.DEFAULT_DIS]});
const emits = defineEmits(['changeCellVal', 'initValidateFlag']);
const changeCellVal=function ({column, newVal,record}){
  emits('changeCellVal',{record,column, newVal})
}
const initValidateFlag=function ({itemId,flag}){
  emits('changeCellVal',{itemId,flag})
}


const flowContainer = inject('flowContainer');
const {
  disabledFun,
  readOnlyFlag,
  hiddenFlag,
  editorFlag
}=useSimpleFlowAclHooks({column,flowContainer,record});

</script>

<style type="text/css" lang="less" scoped>
.orgCell {
  cursor: pointer;
}
</style>

